import { useCallback, useEffect, useState } from 'react';

export const useElementOffsetHeight = ({
  targetId,
  enabled = true,
}: {
  targetId: string;
  enabled?: boolean;
}) => {
  const [offsetHeight, setOffsetHeight] = useState<number>(0);

  const updateOffsetHeight = useCallback(() => {
    const headerElement = document.getElementById(targetId);
    if (!headerElement) {
      return;
    }
    setOffsetHeight(headerElement.clientHeight);
  }, [targetId]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    // Required when initial loading screen
    updateOffsetHeight();

    window.addEventListener('resize', updateOffsetHeight);

    return () => {
      window.removeEventListener('resize', updateOffsetHeight);
    };
  }, [enabled, updateOffsetHeight]);

  return offsetHeight;
};
